<div class="p-4 overflow-auto h-[85vh]">

  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Organization Config</h2>
    <p-button icon="pi pi-plus"
      *ngIf="organizationConfig?.length < 1 && !loading"
    label="Add Orgnization Config" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table [value]="organizationConfig" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading">

    <ng-template pTemplate="header">
      <tr>
        <th>Organization ID</th>
        <th>Client Name</th>
        <th>Support Email</th>
        <th>Email Providers</th>
        <th>WhatsApp App</th>
        <th>Payment Gateway</th>
        <th>Notifications</th>
        <th>Txn Fee</th>
        <th>Sub Fee</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-config>
      <tr>
        <td>{{ config.organization_id }}</td>
        <td>{{ config.email_config?.clientName }}</td>
        <td>{{ config.email_config?.support_email_id }}</td>
        <td>
          <ng-container *ngIf="config.email_config">
            <span *ngIf="config.email_config.ses">SES </span>
            <span *ngIf="config.email_config.gmail">Gmail </span>
            <span *ngIf="config.email_config.yahoo">Yahoo</span>
          </ng-container>
        </td>
        <td>{{ config.whats_app_config?.app_name }}</td>
        <td>{{ config.payment_config?.gateway }}</td>
        <td>{{ config.is_notification_enabled ? 'Yes' : 'No' }}</td>
        <td>{{ config.charges?.transaction_fee }}</td>
        <td>{{ config.charges?.subscription_fee }}</td>
        <td>
          <div (click)="setOrgData(config)">
            <p-menu [tabindex]="undefined" #menu [model]="orgActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="10" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10" class="no-data-record-found">
          <p>No records found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>



</div>

<ng-container *ngIf="displayAddModal">
  <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-organization-config (reload)="getOrganizationConfig()" [orgId]="orgId"
      (close)="displayAddModal= false"></app-create-organization-config>
  </p-dialog>
</ng-container>



<ng-container *ngIf="displayEditModal">
  <p-dialog [(visible)]="displayEditModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-organization-config (reload)="getOrganizationConfig()" [orgId]="orgId"
      [type]="'Update'" [orgDataToEdit]="orgDataToEdit"
      (close)="displayEditModal= false"></app-create-organization-config>
  </p-dialog>
</ng-container>